import React, { useCallback, useContext, useEffect, useState } from "react";
import Dropbox from "../../../Component/Dropbox";
import { useLanguage } from "../../../Providers/LanguageContext";
import { SpeechContext } from "../../../Providers/SpeechWrapper";
import HttpClient from "../../../utils/HttpClient";
import DashboardChartFourColumn from "./DashboardChartFourColumn";
import { UserContext } from "../../../Providers/UserWrapper";

function DashboardChartFour({
  time,
  userCode,
  expenseBarChart,
  expenseLineChart,
  salesLineChart,
  profitLineChart,
  selectedYearFromDashboardPage,
}) {
  const { setShowGif, setGifToShow } = useContext(SpeechContext);
  const { isInvestor, isBookKeeper } = useContext(UserContext);

  const { language } = useLanguage();
  const [projects, setProjects] = useState([]);
  const [dashboardFourData, setDashboardFourData] = useState({});
  const [filters, setFilters] = useState({
    dayType: "",
    projectName: "",
  });

  const [expenseData, setExpenseData] = useState([]);
  const [salesData, setSalesData] = useState([]);
  const [profitData, setProfitData] = useState([]);

  // useEffect(() => {
  //     fetchProjects()
  // }, [])

  useEffect(() => {
    fetchProjects();
    setFilters((prev) => ({ ...prev, dayType: time }));
  }, [time]);

  // useEffect(() => {
  // }, [dashboardFourData])

  const [expenseFilter, setExpenseFilter] = useState({
    day: "",
    week: "",
    month: "",
    year: "",
  });
  const [salesFilter, setSalesFilter] = useState({
    day: "",
    week: "",
    month: "",
    year: "",
  });

  const [profitFilter, setProfitFilter] = useState({
    day: "",
    week: "",
    month: "",
    year: "",
  });

  const fetchDashboardFour = async (filt, filteredData) => {
    if (!filteredData) {
      if (filt.dayType && filt.projectName) {
        const res = await HttpClient.requestData(
          isInvestor || isBookKeeper
            ? `investor/investor-dashboard-four-view/${userCode}`
            : "dashboard-four-view",
          "POST",
          filt
        );
        console.log("dashboardFour", res);
        if (res && res.data) {
          if (
            res.message &&
            res.message.trim() === "Dashboard rewards 1 points"
          ) {
            setShowGif(true);
            setGifToShow("Dashboard rewards 1 points");
          }
          setDashboardFourData(res.data);
          setExpenseData(res?.expense || []);
          setSalesData(res?.sales || []);
          setProfitData(res?.profit || []);
        }
      }
    } else {
      if (filt.dayType && filt.projectName) {
        let res = null;
        if (
          filteredData.day &&
          !filteredData.week &&
          !filteredData.month &&
          !filteredData.year
        ) {
          res = await HttpClient.requestData(
            isInvestor || isBookKeeper
              ? `investor/investor-dashboard-four-view/${userCode}`
              : "dashboard-four-view",
            "POST",
            {
              ...filt,
              day: filteredData.day,
            }
          );
        } else if (
          !filteredData.day &&
          filteredData.week &&
          !filteredData.month &&
          !filteredData.year
        ) {
          res = await HttpClient.requestData(
            isInvestor || isBookKeeper
              ? `investor/investor-dashboard-four-view/${userCode}`
              : "dashboard-four-view",
            "POST",
            {
              ...filt,
              week: filteredData.week,
            }
          );
        } else if (
          !filteredData.day &&
          !filteredData.week &&
          filteredData.month &&
          !filteredData.year
        ) {
          res = await HttpClient.requestData(
            isInvestor || isBookKeeper
              ? `investor/investor-dashboard-four-view/${userCode}`
              : "dashboard-four-view",
            "POST",
            {
              ...filt,
              month: filteredData.month,
            }
          );
        } else if (
          !filteredData.day &&
          !filteredData.week &&
          !filteredData.month &&
          filteredData.year
        ) {
          res = await HttpClient.requestData(
            isInvestor || isBookKeeper
              ? `investor/investor-dashboard-four-view/${userCode}`
              : "dashboard-four-view",
            "POST",
            {
              ...filt,
              year: filteredData.year,
            }
          );
        }
        console.log("dashboardFour", res);
        if (res && res.data) {
          if (
            res.message &&
            res.message.trim() === "Dashboard rewards 1 points"
          ) {
            setShowGif(true);
            setGifToShow("Dashboard rewards 1 points");
          }
          setDashboardFourData(res.data);
          setExpenseData(res?.expense || []);
          setSalesData(res?.sales || []);
          setProfitData(res?.profit || []);
        }
      }
    }
  };

  useEffect(() => {
    if (
      !expenseFilter.day &&
      !expenseFilter.week &&
      !expenseFilter.month &&
      !expenseFilter.year &&
      !salesFilter.day &&
      !salesFilter.week &&
      !salesFilter.month &&
      !salesFilter.year &&
      !profitFilter.day &&
      !profitFilter.week &&
      !profitFilter.month &&
      !profitFilter.year
    ) {
      fetchDashboardFour(filters);
    }
  }, [filters, userCode]);

  useEffect(() => {
    if (
      expenseFilter.day ||
      expenseFilter.week ||
      expenseFilter.month ||
      expenseFilter.year
    ) {
      fetchDashboardFour(filters, expenseFilter);
    }
  }, [filters, userCode, expenseFilter]);

  useEffect(() => {
    if (
      salesFilter.day ||
      salesFilter.week ||
      salesFilter.month ||
      salesFilter.year
    ) {
      // pass salesFilter as the second argument
      fetchDashboardFour(filters, salesFilter);
    }
  }, [filters, userCode, salesFilter]);

  useEffect(() => {
    if (
      profitFilter.day ||
      profitFilter.week ||
      profitFilter.month ||
      profitFilter.year
    ) {
      fetchDashboardFour(filters, profitFilter);
    }
  }, [filters, userCode, profitFilter]);

  const uniqueProjectName = (arr) => {
    const uniqueIds = [];
    const unique = arr.filter((element) => {
      const isDuplicate = uniqueIds.includes(element.projectName);
      if (!isDuplicate) {
        uniqueIds.push(element.projectName);
        return true;
      }
      return false;
    });
    console.log("unique", unique);
    return unique;
  };

  const fetchProjects = async () => {
    const res = await HttpClient.requestData(
      isInvestor || isBookKeeper
        ? `investor/investor-projectname/${userCode}`
        : "projectname",
      "GET",
      {}
    );
    console.log("projectnamed", res);
    if (res && res.status) {
      let arr1 = uniqueProjectName(res.data);
      setProjects(arr1);
    } else {
      console.log("error", res);
    }
  };

  const getValue = (event) => {
    const value = event.target.value;
    console.log(value, "Seelectvalue", value !== language.select_project);
    if (value !== language.select_project) {
      setFilters((prev) => ({ ...prev, projectName: value }));
    }
  };
  return (
    <div>
      <Dropbox
        data={projects}
        getValue={getValue}
        text={language.select_project}
      />

      {Object.values(dashboardFourData).length > 0 && (
        <DashboardChartFourColumn
          data={dashboardFourData}
          expenseData={expenseData}
          salesData={salesData}
          profitData={profitData}
          time={time}
          setExpenseFilter={setExpenseFilter}
          setSalesFilter={setSalesFilter}
          setProfitFilter={setProfitFilter}
          expenseBarChart={expenseBarChart}
          expenseLineChart={expenseLineChart}
          salesLineChart={salesLineChart}
          profitLineChart={profitLineChart}
          selectedYearFromDashboardPage={selectedYearFromDashboardPage}
        />
      )}
    </div>
  );
}

export default DashboardChartFour;
